var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"collapsible-components"}},[_c('ExpansionPanel',{attrs:{"header":"Reports Detail"}},[_c('ReportsDetails')],1),_c('ExpansionPanel',{attrs:{"header":"Label References"}},[_c('LabelReferenceTable')],1),_c('ExpansionPanel',{attrs:{"header":"Select Images By Structures"}},[_c('FileManagement',{attrs:{"type":"ai"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }